const About = () => {
  const name = 'Hal Barnett';
  return <div>About {name}</div>;
};

export default About;
